var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_vm._t("sidebar",null,{"showSidebar":_vm.showSidebar}),_c('b-col',{staticClass:"ml-sm-auto",class:_vm.contentClass,attrs:{"cols":"12","md":"9","xl":"10"}},[_vm._t("default")],2)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }